import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.starts-with";

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable @typescript-eslint/no-use-before-define */
import { Kind } from '../typedoc-types';
export var getLinkedNode = function getLinkedNode(def) {
  if (def === null || def === void 0 ? void 0 : def.type) {
    if (def.type.type === 'reflection') return def.type.declaration;
    if (def.type.type === 'reference') return def.type.reference;
  }

  return undefined;
};
export var isInternalType = function isInternalType(node) {
  return node.name.startsWith('__');
};
export var isObjecty = function isObjecty(node) {
  var _node$typedocs;

  return node.kind === Kind.Interface || node.kind === Kind.ObjectLiteral || node.kind === Kind.TypeLiteral && !!((_node$typedocs = node.typedocs) === null || _node$typedocs === void 0 ? void 0 : _node$typedocs.length);
};
export var getReadableName = function getReadableName(node) {
  // grumble
  if (node.name === '__namedParameters') return '__namedParameters';
  return isInternalType(node) ? node.originalName : node.name;
};
export var getFunctionNode = function getFunctionNode(definition) {
  var _definition$signature, _definition$parameter, _definition$signature2;

  if (!definition) return false;

  if (definition.kind === Kind.TypeLiteral && ((_definition$signature = definition.signatures) === null || _definition$signature === void 0 ? void 0 : _definition$signature.length)) {
    return getFunctionNode(definition.signatures[0]);
  }

  if (definition.kind === Kind.CallSignature || ((_definition$parameter = definition.parameters) === null || _definition$parameter === void 0 ? void 0 : _definition$parameter.length) || ((_definition$signature2 = definition.signatures) === null || _definition$signature2 === void 0 ? void 0 : _definition$signature2.length)) return definition; // return the node if it's a method but no signatures

  if (definition.kind === Kind.Method) {
    return definition;
  }

  return getFunctionNode(getLinkedNode(definition));
};
export var getReturnType = function getReturnType(definition) {
  if (definition.kind === Kind.CallSignature) {
    return definition.type;
  }

  if (definition.kind === Kind.Function || definition.kind === Kind.Method || definition.kind === Kind.FunctionOrMethod || definition.kind === Kind.TypeLiteral) {
    return definition.signatures.length ? getReturnType(definition.signatures[0]) : {
      name: 'void',
      type: 'intrinsic'
    }; // Methods that have no params or return value are (): void
  }

  var typeNode = getLinkedNode(definition);
  if (typeNode) return getReturnType(typeNode);
  return definition.type || definition || {
    name: '???',
    type: 'intrinsic'
  };
};
export var getParams = function getParams(def, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$includeTypes = _ref.includeTypes,
      includeTypes = _ref$includeTypes === void 0 ? true : _ref$includeTypes,
      _ref$ignoreParams = _ref.ignoreParams,
      ignoreParams = _ref$ignoreParams === void 0 ? [] : _ref$ignoreParams;

  return def.parameters ? def.parameters.filter(function (param) {
    return !ignoreParams.includes(param.name);
  }).map(function (param) {
    var name = getReadableName(param);
    var type = param.type && includeTypes ? ": " + typeExpression(param.type) : '';
    return "" + (param.flags.isRest ? '...' : '') + name + (param.flags.isOptional ? '?' : '') + type;
  }) : [];
};

var isType = function isType(node) {
  return typeof node.type === 'string';
};

export function getPropertyKey(node) {
  return "" + node.name + (node.flags.isOptional ? '?' : '');
}
export function getGenericSuffix(typeParameters) {
  return (typeParameters === null || typeParameters === void 0 ? void 0 : typeParameters.length) ? "<" + typeParameters.map(function (p) {
    return p.name;
  }).join(', ') + ">" : '';
}
export function tsFunctionExpression(definition, opts) {
  if (opts === void 0) {
    opts = {
      arrowStyle: true
    };
  }

  var def = getFunctionNode(definition);
  if (!def) return null;
  var typeParams = getGenericSuffix(definition.typeParameter);
  var params = getParams(def);
  var returnType = getReturnType(definition);
  return typeParams + "(" + params.join(', ') + ")" + (opts.arrowStyle ? ' => ' : ': ') + typeExpression(returnType, opts);
}
export function propertyEntries(typedocs) {
  if (typedocs === void 0) {
    typedocs = [];
  }

  var result = [];

  var _loop = function _loop() {
    var _child$signatures;

    var child = _step.value;

    if (child.kind === Kind.Method && ((_child$signatures = child.signatures) === null || _child$signatures === void 0 ? void 0 : _child$signatures.length)) {
      child.signatures.forEach(function (sig) {
        return result.push([child, sig]);
      });
    } else {
      result.push([child, child]);
    }
  };

  for (var _iterator = _createForOfIteratorHelperLoose(typedocs), _step; !(_step = _iterator()).done;) {
    _loop();
  }

  return result;
}
export default function typeExpression(type, opts) {
  var _type$typedocs;

  if (opts === void 0) {
    opts = {};
  }

  function printProperties(innerType) {
    return propertyEntries(innerType.typedocs).reduce(function (acc, _ref2) {
      var keyNode = _ref2[0],
          child = _ref2[1];
      var key = getPropertyKey(keyNode);
      var value;

      if (child.kind === Kind.Method) {
        value = key + "(): void";
      } else if (keyNode.kind === Kind.Method) {
        value = "" + key + tsFunctionExpression(child, {
          arrowStyle: false
        });
      } else {
        value = key + ": " + typeExpression(child.type || child, opts);
      }

      return acc ? acc + "; " + value : value;
    }, '');
  }

  if (!type) return null;

  if (isType(type)) {
    if (type.type === 'intrinsic' || type.type === 'typeParameter' || type.type === 'unknown') {
      return type.name;
    }

    if (type.type === 'array') {
      return type.elementType ? typeExpression(type.elementType, opts) + "[]" : 'Array';
    }

    if (type.type === 'conditional') {
      return typeExpression(type.checkType, opts) + " extends " + typeExpression(type.checkType, opts) + " ? " + typeExpression(type.trueType, opts) + " : " + typeExpression(type.falseType, opts);
    }

    if (type.type === 'indexedAccess') {
      return typeExpression(type.objectType, opts) + "[" + typeExpression(type.indexType, opts) + "]";
    }

    if (type.type === 'inferred') {
      return "infer " + type.name;
    }

    if (type.type === 'intersection') {
      return type.types.map(function (tt) {
        return typeExpression(tt, opts);
      }).join(' & ');
    }

    if (type.type === 'predicate') {
      return "" + (type.asserts ? 'asserts ' : '') + type.name + (type.targetType ? typeExpression(type.targetType, opts) : '');
    }

    if (type.type === 'query') {
      return "typeof " + typeExpression(type.queryType, opts);
    }

    if (type.type === 'reference') {
      var _type$typeArguments;

      var typeArgs = ((_type$typeArguments = type.typeArguments) === null || _type$typeArguments === void 0 ? void 0 : _type$typeArguments.length) && "<" + type.typeArguments.map(function (t) {
        return typeExpression(t, opts);
      }).join(', ') + ">"; // TypeDoc doesn't always type functions correctly

      if (!type.reference && type.name === '(Anonymous function)') {
        return 'function';
      } // TODO handle type params for linked nodes?


      return type.reference ? typeExpression(type.reference, opts) : "" + type.name + (typeArgs !== null && typeArgs !== void 0 ? typeArgs : '');
    }

    if (type.type === 'reflection') {
      return typeExpression(type.declaration, opts);
    }

    if (type.type === 'stringLiteral') {
      return "\"" + type.value + "\"";
    }

    if (type.type === 'tuple') {
      return "[" + type.elements.map(function (e) {
        return typeExpression(e, opts);
      }).join(',') + "]";
    }

    if (type.type === 'typeOperator') {
      return "" + type.operator + typeExpression(type.target, opts);
    }

    if (type.type === 'union') {
      return type.types.map(function (tt) {
        return typeExpression(tt, opts);
      }).join(' | ');
    }
  }

  if (getFunctionNode(type)) {
    var _opts;

    return tsFunctionExpression(type, {
      compact: (_opts = opts) === null || _opts === void 0 ? void 0 : _opts.compact,
      arrowStyle: true
    });
  }

  if (type.kind === Kind.TypeAlias) {
    var _opts2;

    if (type.type && !((_opts2 = opts) === null || _opts2 === void 0 ? void 0 : _opts2.compact)) return typeExpression(type.type, opts);
    return "" + type.name + getGenericSuffix(type.typeParameter);
  }

  if (type.kind === Kind.Class) {
    return "" + type.name + getGenericSuffix(type.typeParameter);
  }

  if (type.kind === Kind.Interface) {
    var _opts3;

    var name = "" + type.name + getGenericSuffix(type.typeParameter);
    if ((_opts3 = opts) === null || _opts3 === void 0 ? void 0 : _opts3.compact) return name;
    return name + " { " + printProperties(type) + "; }";
  } // { Object literal }


  if (isObjecty(type) && ((_type$typedocs = type.typedocs) === null || _type$typedocs === void 0 ? void 0 : _type$typedocs.length)) {
    var _opts4;

    if ((_opts4 = opts) === null || _opts4 === void 0 ? void 0 : _opts4.compact) {
      return !isInternalType(type) ? type.name : 'object';
    }

    return "{ " + printProperties(type) + "; }";
  }

  return '???';
}